import { Button } from '@/components';
import { showAlert } from '@/utils';
import React, { lazy, memo, Suspense, useState } from 'react';

const ModalAddFooterInfo = lazy(() => import('./modal-add.view'));
interface IProps {
	fetchData: () => void;
	total: number;
}

const AddFooterInfo: React.FC<IProps> = ({ fetchData, total }) => {
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		if (total >= 10) {
			showAlert('웹 사이트 정보는 최대 10개 등록할 수 있습니다.');
			return;
		}
		setOpen(true);
	};
	const handleClose = () => setOpen(false);
	return (
		<div>
			<Button secondary onClick={handleOpen}>
				추가
			</Button>
			{open && (
				<Suspense fallback={null}>
					<ModalAddFooterInfo
						open={open}
						onCancel={handleClose}
						fetchData={fetchData}
					/>
				</Suspense>
			)}
		</div>
	);
};

export default memo(AddFooterInfo);
